import {useState, useContext} from 'react'
import {Row, Col} from 'react-bootstrap'
import Card from '../ui/Card'
import ContextModal from './contextModal'
import CommonService from '../../services/CommonService'
import { UserContext } from "../../UseContext"
import FinalSaleReportService from "../../services/FinalSaleReportService"
import { toast } from 'react-toastify'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import moment from 'moment'

const MKRLocalObligors = (props) => {
    const [openContextModal, setOpenContextModal] = useState(false);
    const params = useParams();
    const location = useLocation();
    const cdiacNo = params.cdiac;
    const user = useContext(UserContext);
    let markRoosLocalOblig = location.state.reportData;   

    if(!location.state.reportData){
        markRoosLocalOblig = location.state.markRoosLocalOblig
    }
    const navigate = useNavigate();
    
    const backToDashboard = () => {
        const dashboardSelectionObj = JSON.parse(sessionStorage.getItem('dashboardSelection'));
        navigate("/dashboard", {state: {dashboardSelection: dashboardSelectionObj}});
    }

    const [stateValues, setStateValues] = useState({
        fiscalYrEndDate : markRoosLocalOblig.fiscalYrEndDate
    })

    const handleChange = (e) => {
        const {name, value} = e.target;

        setStateValues(prevState => ({
            ...stateValues, [name]: moment('6/30/' + value).format('MM/DD/YYYY')
        })
        )
    }

    const handleSubmit = () => {

        if(markRoosLocalOblig.mkrLobId === null || 
            CommonService.getFullYear(stateValues.fiscalYrEndDate) !== CommonService.getFullYear(markRoosLocalOblig.fiscalYrEndDate) 
            ){
            var obj ={
                "msgId": null,
                "sysId": null,
                "opr": "createMKRLOB",
                "hdrStruct": null,
                "queryParam": null,
                "reqData": {"cdiacNbr": cdiacNo, "marksRoosLocalObligor": {
                    "fiscalYrEndDate" : stateValues.fiscalYrEndDate,
                    "finalSaleId": markRoosLocalOblig.finalSaleId,
                     "createUser": CommonService.getUserName(user),
                    "lastUpdateUser": CommonService.getUserName(user),
                    "emailId": user
                }
    
                }
              } ;
          
            FinalSaleReportService.createMKRLOB(obj)
            .then((res) => res)
            .then(async (result) => {
                if (result.data.errors && result.data.errors.length > 0){
                    toast.error(result.data.errors[0].message);
                    return;
                }
                else{
                    toast.success("The Mark Roos Local Obligor was created  successfully.");
                    markRoosLocalOblig.mkrLobId = result.data.responses[0].marksRoosLocalObligorId;
                    setOpenContextModal(true);
                  }
            });

            
        }
        else{

            var anotherobj ={
                "msgId": null,
                "sysId": null,
                "opr": "validateMKRLOB",
                "hdrStruct": null,
                "queryParam": null,
                "reqData": {
                    "cdiacNbr": cdiacNo, 
                    "marksRoosLocalObligor": {
                        "fiscalYrEndDate" : stateValues.fiscalYrEndDate
                    }
                }
              } ;
          
            FinalSaleReportService.validateMKRLOB(anotherobj)
            .then((res) => res)
            .then(async (result) => {
                if (result.data.errors && result.data.errors.length > 0){
                    toast.error(result.data.errors[0].message);
                    return;
                }
                else{
                    var obj ={
                        "msgId": null,
                        "sysId": null,
                        "opr": "createMKRLOB",
                        "hdrStruct": null,
                        "queryParam": null,
                        "reqData": {
                            "cdiacNbr": cdiacNo,
                            "marksRoosLocalObligor": {
                                "fiscalYrEndDate" : stateValues.fiscalYrEndDate,
                                "finalSaleId": markRoosLocalOblig.finalSaleId,
                                "createUser": CommonService.getUserName(user),
                                "lastUpdateUser": CommonService.getUserName(user),
                                "emailId": user
                            }
                        }
                      } ;
                  
                    FinalSaleReportService.createMKRLOB(obj)
                    .then((res) => res)
                    .then(async (result) => {
                        if (result.data.errors && result.data.errors.length > 0){
                            toast.error(result.data.errors[0].message);
                            return;
                        }
                        else{
                            toast.success("The Mark Roos Local Obligor was created  successfully.");
                            markRoosLocalOblig.mkrLobId = result.data.responses[0].marksRoosLocalObligorId;
                            setOpenContextModal(true);
                          }
                    });
                  }
            });
        }
    }

    return (
        <Card>
            <div>
                <div className="panel panel-default">
                    <div className="panel-heading" role="tab"> 
                        <div className="container">
                            <div className="panel-title">
                                <h1 className="main-title">Marks Roos Yearly Fiscal Status Report For Local Obligors</h1>
                            </div>
                        </div>
                    </div>
                    <div className="panel-body" style={{padding: '10px 0'}}>
                        <div className="container">
                            <div>
                            <Row>
                                <Col>
                                    <div className="dflex">
                                        <div><label> CDIAC #: </label></div>
                                        <div><input type="text" className="form-control" defaultValue={cdiacNo} disabled/></div>
                                    </div>
                                    <div className="dflex mt-2">
                                       <div><label><span className="required">* </span>Balances Reported as of June 30,</label></div>
                                       <div><input type="number" className="form-control" disabled="true" onChange={(e)=>handleChange(e)} maxLength="4" name="fiscalYrEndDate" defaultValue={CommonService.getFullYear(stateValues.fiscalYrEndDate)}/></div>
                                    </div>
                                </Col>
                            </Row>
                            </div>

                            <div style={{overflow: 'auto'}}>
                            <button type="button" className="custom-button" onClick={(e)=>handleSubmit(e)} style={{float: 'right'}} >Submit</button>
   
                            <button 
                                type="button"
                                className="custom-button" 
                                onClick={()=>backToDashboard()}>Back to Dashboard
                                </button>
                       
                               
                            </div>
                        </div>
                    </div>

                

                </div>
            </div>

            {openContextModal && <ContextModal onModalClose={()=>setOpenContextModal(false)} cdiacNo={cdiacNo} finalSaleId = {markRoosLocalOblig.finalSaleId}  markRoosLocalOblig={markRoosLocalOblig}/>
            }
            
        </Card>
    )
}

export default MKRLocalObligors
